import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/main-logo1x1.png'
import _imports_1 from '@/assets/main-logo1x1-dark.png'


const _hoisted_1 = { class: "min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800 p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = { class: "absolute top-4 right-4 z-20" }
const _hoisted_3 = { class: "card w-full max-w-md space-y-6 sm:space-y-8 p-4 sm:p-6 lg:p-8" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = {
  key: 0,
  class: "mt-4 rounded-md bg-success-bg dark:bg-success-dark-bg p-3 sm:p-4"
}
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex-shrink-0" }
const _hoisted_8 = { class: "ml-3" }
const _hoisted_9 = { class: "text-sm text-success-text dark:text-success-dark-text" }
const _hoisted_10 = { class: "space-y-4" }
const _hoisted_11 = { class: "mt-1" }
const _hoisted_12 = { class: "mt-1 relative" }
const _hoisted_13 = ["type"]
const _hoisted_14 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-3 sm:space-y-0" }
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = ["disabled"]

import { ref, computed } from 'vue'
import { useTitle } from '@/composables/ui/useTitle'
import { useLogin } from '@/composables/auth/useLogin'
import { useThemeStore } from '@/stores/theme'
import { Sun, Moon, CheckCircle, Eye, EyeOff } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const appTitle = computed(() => process.env.VUE_APP_TITLE || 'Empathy Health Services, Inc.')

useTitle(`Login - ${appTitle.value}`)

const { email, password, loading, handleLogin } = useLogin()
const successMessage = ref('')
const rememberMe = ref(false)
const showPassword = ref(false)

// Theme logic (same as AppLayout)
const themeStore = useThemeStore()
const isDarkMode = computed(() => themeStore.isDarkMode)
const toggleTheme = () => {
  themeStore.toggleTheme()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "flex items-center px-3 py-2 rounded-md bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 shadow focus:outline-none focus:ring-2 focus:ring-indigo-500",
        onClick: toggleTheme
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(isDarkMode.value ? _unref(Sun) : _unref(Moon)), { class: "h-5 w-5" }))
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mx-auto text-primary dark:text-primary-dark" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Logo",
            class: "h-full w-full object-contain block dark:hidden"
          }),
          _createElementVNode("img", {
            src: _imports_1,
            alt: "Logo Dark",
            class: "h-full w-full object-contain hidden dark:block"
          })
        ], -1)),
        (successMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_unref(CheckCircle), { class: "h-5 w-5 text-success dark:text-success-dark" })
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(successMessage.value), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("form", {
        class: "mt-6 sm:mt-8 space-y-4 sm:space-y-6",
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_unref(handleLogin)(rememberMe.value)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", null, [
            _cache[6] || (_cache[6] = _createElementVNode("label", {
              for: "email-address",
              class: "label"
            }, " Email address ", -1)),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                id: "email-address",
                name: "email",
                type: "email",
                autocomplete: "email",
                required: "",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
                class: "input",
                placeholder: "you@example.com"
              }, null, 512), [
                [_vModelText, _unref(email)]
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[7] || (_cache[7] = _createElementVNode("label", {
              for: "password",
              class: "label"
            }, " Password ", -1)),
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                id: "password",
                name: "password",
                type: showPassword.value ? 'text' : 'password',
                autocomplete: "current-password",
                required: "",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
                class: "input pr-10",
                placeholder: "••••••••"
              }, null, 8, _hoisted_13), [
                [_vModelDynamic, _unref(password)]
              ]),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value)),
                class: "absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300"
              }, [
                (showPassword.value)
                  ? (_openBlock(), _createBlock(_unref(EyeOff), {
                      key: 0,
                      class: "h-5 w-5"
                    }))
                  : (_openBlock(), _createBlock(_unref(Eye), {
                      key: 1,
                      class: "h-5 w-5"
                    }))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              id: "remember-me",
              name: "remember-me",
              type: "checkbox",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((rememberMe).value = $event)),
              class: "h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded"
            }, null, 512), [
              [_vModelCheckbox, rememberMe.value]
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("label", {
              for: "remember-me",
              class: "ml-2 block text-sm text-primary-text dark:text-primary-dark-text"
            }, " Remember me ", -1))
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "submit",
            disabled: _unref(loading),
            class: "btn btn-primary w-full"
          }, _toDisplayString(_unref(loading) ? 'Signing in...' : 'Sign in'), 9, _hoisted_16)
        ])
      ], 32)
    ])
  ]))
}
}

})